import { PageModal, Typography } from '@otp/ui';
import { Rule } from '@otp/icons';
import { useTranslation } from 'react-i18next';
import { LoginRuleCriteriaForm } from './form';
import { LoginRuleCriteria } from 'src/components/login-rules/form/types';

interface LoginRuleCriteriaModalProps {
  onClose: () => void;
  onSubmit: (data: LoginRuleCriteria) => void;
  defaultValues?: LoginRuleCriteria;
}

export const LoginRuleCriteriaModal = ({
  onClose,
  onSubmit,
  defaultValues,
}: LoginRuleCriteriaModalProps) => {
  const { t } = useTranslation();
  const isEditing = !!defaultValues;

  const onSave = (data: LoginRuleCriteria) => {
    onSubmit(data);
    onClose();
  };

  return (
    <PageModal
      open
      onClose={onClose}
      maxWidth="md"
      fullWidth={true}
      title={
        <div className="flex gap-2 items-center">
          <Rule className="scale-[1.3] p-[3px]" />
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            className="uppercase"
          >
            {t(
              `login-rules.form.modal.title-${!isEditing ? 'create' : 'edit'}`,
            )}
          </Typography>
        </div>
      }
    >
      <LoginRuleCriteriaForm
        onSubmit={onSave}
        onCancel={onClose}
        defaultValues={defaultValues}
      />
    </PageModal>
  );
};
